import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export const ProtectedRoute = () => {
    const isVerified = localStorage.getItem('is_verified');
    const lastStep = localStorage.getItem('last_complete_step')?.trim();
    const auth = localStorage.getItem('token');
    const accountType = localStorage.getItem('account_type');
    const location = useLocation();
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            // Clear session data only if the user is on one of the specified routes
            if (["/phone-verification-otp", "/careerDetails", "/contactReligion"].includes(location.pathname)) {
                localStorage.removeItem('token');
                localStorage.removeItem('is_verified');
                localStorage.removeItem('last_complete_step');
                // Optionally, show a confirmation dialog
                event.returnValue = ""; // Show confirmation dialog (default message)
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [location.pathname]);
    if (!auth) {
        return <Navigate to="/login" replace />;
    }
    
    if ((location.pathname === "/chatList" || location.pathname === "/chat") && accountType === "Free") {
        return <Navigate to="/upgrade" replace />;
    }
    // Redirect to phone verification if the user is not verified
    if (isVerified !== "1") {
        if (location.pathname !== "/phone-verification-otp") {
            console.log("Navigating to Phone Verification OTP");
            return <Navigate to="/phone-verification-otp" replace />;
        }
    }
    if (isVerified === "1" && lastStep === "step_1_flag" && location.pathname !== "/careerDetails") {
        return <Navigate to="/careerDetails" replace />;
    }
    if (lastStep === "step_2_flag" && location.pathname !== "/contactReligion") {
        return <Navigate to="/contactReligion" replace />;
    }
    if (isVerified === "1" && location.pathname === "/phone-verification-otp") {
        return <Navigate to="/" replace />;
    }
    const stepNumber = parseInt(lastStep.split('_')[1]);
    if (stepNumber >= 3) {
        const restrictedRoutes = ["/careerDetails", "/contactReligion"];
        if (restrictedRoutes.includes(location.pathname)) {
            return <Navigate to="/" replace />;
        }
    }



    return <Outlet replace />;
};
